import { mediaItems } from '@/mocks/animeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            精彩视频
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            精选动漫名场面混剪与精彩预告，视觉盛宴不容错过
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:scale-[1.02] cursor-pointer"
            >
              <div className="relative w-full h-[200px] md:h-[220px] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.currentTarget as HTMLImageElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-foreground-900/60 flex items-center justify-center group-hover:bg-primary-500/80 transition-colors">
                    <i className="ri-play-fill text-background-50 text-xl md:text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-700 text-xs font-medium">
                    {item.type}
                  </span>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="font-heading text-sm md:text-base text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}